import React from 'react';
import {
    Fab,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Divider,
    Box,
    Typography,
    Tooltip,
    Radio as CustomRadio,
    type SimplePaletteColorOptions,
    Grid,
} from '@mui/material';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import { type THEME_LIST, setTheme, setDarkMode } from '@europrocurement/l2d-domain';
import { customizerSelector } from '../../../redux/storeConfig/selectors';
import { NamedTheme, themesOptions } from '../../../assets/global/Theme-variable';

export const UserSecurityParameters: React.FunctionComponent = function () {
    const customizer = useSelector(customizerSelector, shallowEqual);

    const dispatch = useDispatch();

    const thColors: { id: number; bgColor: string; iconColor: string; disp: THEME_LIST }[] =
        themesOptions.map((theme: NamedTheme, id: number) => {
            const bgColor = theme.palette?.primary
                ? (theme.palette.primary as SimplePaletteColorOptions).main
                : theme.palette?.background?.paper || '#fff';
            const iconColor = theme.palette?.secondary
                ? (theme.palette.secondary as SimplePaletteColorOptions).main
                : theme.palette?.text?.secondary || '#000';

            return {
                id,
                bgColor,
                iconColor,
                disp: theme.name,
            };
        });

    return (
        <>
            <Box p={2}>
                <Typography variant="h3">Thèmes</Typography>
            </Box>

            <Divider />
            <Box p={2}>
                {/* ------------ Dark light theme setting ------------- */}
                <Typography
                    variant="h4"
                    gutterBottom
                >
                    Options de thème
                </Typography>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="theme"
                        name="theme"
                        value={customizer.activeMode}
                        onChange={(event) =>
                            dispatch(setDarkMode(event.target.value as 'dark' | 'light'))
                        }
                    >
                        <FormControlLabel
                            value="light"
                            control={<CustomRadio />}
                            label="Thème claire"
                        />
                        <FormControlLabel
                            value="dark"
                            control={<CustomRadio />}
                            label="Thème sombre"
                        />
                    </RadioGroup>
                </FormControl>
                <Box pt={3} />
                {/* ------------ Navbar Color setting ------------- */}
                <Typography
                    variant="h4"
                    gutterBottom
                >
                    Couleurs du thème
                </Typography>
                <Grid
                    container
                    columns={4}
                    spacing={2}
                    sx={{ maxWidth: '25rem' }}
                >
                    {thColors.map((thcolor) => (
                        <Grid
                            item
                            xs={1}
                            key={thcolor.id}
                        >
                            <Tooltip
                                title={thcolor.disp}
                                placement="top"
                                sx={{ margin: 'auto' }}
                            >
                                <Fab
                                    color="primary"
                                    style={{ backgroundColor: thcolor.bgColor }}
                                    size="small"
                                    onClick={() => dispatch(setTheme(thcolor.disp))}
                                    aria-label={thcolor.bgColor}
                                >
                                    {customizer.activeTheme === thcolor.disp ? (
                                        <CheckCircleIcon
                                            style={{ color: thcolor.iconColor }}
                                            fontSize="large"
                                        />
                                    ) : (
                                        <CircleIcon
                                            style={{ color: thcolor.iconColor }}
                                            fontSize="large"
                                        />
                                    )}
                                </Fab>
                            </Tooltip>
                        </Grid>
                    ))}
                </Grid>

                <Box pt={3} />
            </Box>
        </>
    );
};
